<template>
  <li
    class="group relative p-2 cursor-pointer rounded-lg hover:bg-gray-100 border border-transparent font-medium"
    :class="[
      selected && 'text-blue-600 !bg-blue-50 hover:!border-transparent-200 font-bold',
   ]"
  >
    <span>
      {{ name }}
    </span>
  </li>
</template>

<script>

export default {
  props: ['selected', 'name'],
}

</script>
